import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";
import AddBusiness from "./screens/addBusiness";
import AddCategory from "./screens/addCategories";
import AddCoupons from "./screens/addCoupons";
import AddDynamicForm from "./screens/addDynamicForm";
import AddPlansPrice from "./screens/addPlanPrice";
import AddPlans from "./screens/addPlans";
import AddTemplates from "./screens/addTemplates";
import AppointmentScreen from "./screens/appointmentScreen";
import Billing from "./screens/billing";
import PosBilling from "./screens/posBilling";

import BookAppointment from "./screens/bookAppointmentScreen";
import BusinessDetails from "./screens/businessDetails";
import BusinessList from "./screens/businessList";
import Categories from "./screens/categories";
import IndustrySettings from "./screens/industrySettings";
import CategoryDetails from "./screens/categoryDetails";
import Coupons from "./screens/coupen";
import PatientScreen from "./screens/patientScreen";
import ProductsScreen from "./screens/productsScreen";
import DocumentScreen from "./screens/documentScreen";
import EditDynamicForm from "./screens/editPersetScreen";
import FieldScreen from "./screens/fieldScreen";
import Home from "./screens/home";
import Login from "./screens/login";
import PlanPrices from "./screens/planPrices";
import Plans from "./screens/plans";
import Profile from "./screens/profileScreen";
import SelectDatePortion from "./screens/selectDatePortion";
import ServicesScreen from "./screens/servicesScreen";
import StaffScreen from "./screens/staffScreen";
import SuccessPage from "./screens/successPage";
import Templates from "./screens/templates";

import UploadPage from "./screens/uploadPage";
import BookAppointmentStaff from "./screens/bookAppointmentStaff";
import SelectDatePortionStaff from "./screens/selectDatePortionStaff";
import EmailVerify from "./components/emailVerify";
import ChangePassword from "./components/changePassword";
import Register from "./screens/register";
import CompleteSetup from "./screens/completeSetup";
import QrCodeScreen from "./screens/qrCode";
import CompleteSetupGoogle from "./screens/completeSetupGoogle";
import ForgotPasswordVerify from "./screens/forgotPasswordEmail";
import StaffLogin from "./screens/staffLogin";
import AdminLogin from "./screens/adminLogin";
import ReportScreen from "./screens/ReportScreen";
import PricePlan from "./screens/pricePlan";
import SubscriptionBilling from "./screens/subscriptionBilling";
import SettingsScreen from "./screens/settingsScreen";

const RouterApp = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.auth);
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin/" replace />} />
      <Route
        path="/admin/login"
        element={<PublicRoute Component={Login} store={{ state, dispatch }} />}
      />
      <Route
        path="/admin/login/admin"
        element={<PublicRoute Component={AdminLogin} store={{ state, dispatch }} />}
      />
      <Route
        path="/admin/login/staff"
        element={<PublicRoute Component={StaffLogin} store={{ state, dispatch }} />}
      />
      <Route
        path="/admin/register"
        element={
          <Register/>
        // <PublicRoute Component={Register} store={{ state, dispatch }} />
      }
      />
      <Route
        path="/admin/verify"
        element={
          <EmailVerify/>
      }/>
      <Route
        path="/admin/verify/forgot-password"
        element={
          <ForgotPasswordVerify/>
      }/>
      <Route
        path="/admin/qrCode"
        element={
          // <EmailVerify/>
          
        <PrivateRoute Component={QrCodeScreen} store={{ state, dispatch }} />
      }
      />
      <Route
        path="/admin/complete-setup"
        element={
          <CompleteSetup/>
        // <PublicRoute Component={EmailVerify} store={{ state, dispatch }} />
      }
      />
      <Route
        path="/admin/complete-google"
        element={
          <CompleteSetupGoogle/>
        // <PublicRoute Component={EmailVerify} store={{ state, dispatch }} />
      }
      />
      <Route
        path="/admin/change-password"
        element={
          <ChangePassword/>
        // <PublicRoute Component={ChangePassword} store={{ state, dispatch }} />
      }
      />
      <Route
        path="/admin/"
        element={<PrivateRoute Component={Home} store={{ state, dispatch }} />}
      />
      <Route
        path="/admin/business/add"
        element={
          <PrivateRoute Component={AddBusiness} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/business/:id"
        element={
          <PrivateRoute
            Component={BusinessDetails}
            store={{ state, dispatch }}
          />
        }
      />
      <Route
        path="/admin/profile/:id"
        element={
          <PrivateRoute
            Component={Profile}
            store={{ state, dispatch }}
          />
        }
      />
      <Route
        path="/admin/business"
        element={
          <PrivateRoute Component={BusinessList} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/staff"
        element={
          <PrivateRoute Component={StaffScreen} store={{ state, dispatch }} />
        }
      />
      
      <Route
        path="/admin/document"
        element={
          <PrivateRoute Component={DocumentScreen} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/service"
        element={
          <PrivateRoute Component={ServicesScreen} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/patient"
        element={
          <PrivateRoute Component={PatientScreen} store={{ state, dispatch }} />
        }
      />
      {/* Keep /admin/customer route for backward compatibility */}
      <Route
        path="/admin/customer"
        element={
          <PrivateRoute Component={PatientScreen} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/appointment"
        element={
          <PrivateRoute Component={AppointmentScreen} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/products"
        element={
          <PrivateRoute Component={ProductsScreen} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/field"
        element={
          <PrivateRoute Component={FieldScreen} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/templates"
        element={
          <PrivateRoute Component={Templates} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/templates/add"
        element={
          <PrivateRoute Component={AddTemplates} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/billing"
        element={
          <PrivateRoute Component={Billing} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/pos-billing"
        element={
          <PrivateRoute Component={PosBilling} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/coupons"
        element={
          <PrivateRoute Component={Coupons} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/coupons/add"
        element={
          <PrivateRoute Component={AddCoupons} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/plans"
        element={
          <PrivateRoute Component={Plans} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/pricePlan"
        element={
        <PrivateRoute Component={PricePlan} store={{ state, dispatch }} />
      }
      />
      <Route
        path="/admin/subscription/billing"
        element={
          <PrivateRoute Component={SubscriptionBilling} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/plans/add"
        element={
          <PrivateRoute Component={AddPlans} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/plans/add/prices"
        element={
          <PrivateRoute Component={AddPlansPrice} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/plans/:id"
        element={
          <PrivateRoute Component={PlanPrices} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/categories"
        element={
          <PrivateRoute Component={Categories} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/module-settings"
        element={
          <PrivateRoute Component={IndustrySettings} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/categories/add"
        element={
          <PrivateRoute Component={AddCategory} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/report"
        element={
          <PrivateRoute Component={ReportScreen} store={{ state, dispatch }} />
        }
      />
      <Route
        path="/admin/settings"
        element={
          <PrivateRoute Component={SettingsScreen} store={{ state, dispatch }} />
        }
      />
        <Route
          path="/admin/categories/:id"
          element={
            <PrivateRoute Component={CategoryDetails} store={{ state, dispatch }} />
          }
        />
          <Route
            path="/admin/categories/:id/forms/add"
            element={
              <PrivateRoute Component={AddDynamicForm} store={{ state, dispatch }} />
            }
          />
          <Route
            path="/admin/categories/:id/forms/:form_id"
            element={
              <PrivateRoute Component={EditDynamicForm} store={{ state, dispatch }} />
            }
          />
    </Routes>
  );
};

export default RouterApp;
